import { render, staticRenderFns } from "./ComplianceSubcategoryGrid.vue?vue&type=template&id=807c4e78"
import script from "./ComplianceSubcategoryGrid.vue?vue&type=script&lang=js"
export * from "./ComplianceSubcategoryGrid.vue?vue&type=script&lang=js"
import style0 from "./ComplianceSubcategoryGrid.vue?vue&type=style&index=0&id=807c4e78&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports